import { render, staticRenderFns } from "./BatchRelQrtlyTtyStmt.vue?vue&type=template&id=14332bdc&"
import script from "./BatchRelQrtlyTtyStmt.vue?vue&type=script&lang=js&"
export * from "./BatchRelQrtlyTtyStmt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports